if (window.innerWidth >= 750) {
  function loadGallerySlides(gallery, attempt) {
    if (gallery._desktopSlidesLoaded) return false;
    var instance = gallery._instance;
    if (!instance) {
      // Bounded at ~3s. A gallery whose custom element has not upgraded by now
      // is not going to, and the unbounded version left a 100ms timer running
      // per card for the life of the page -- dozens of them on a full
      // collection, forever.
      attempt = (attempt || 0) + 1;
      if (attempt > 30) return false;
      setTimeout(function () { loadGallerySlides(gallery, attempt); }, 100);
      return false;
    }
    gallery._desktopSlidesLoaded = true;
    if (!instance.slidesLoaded) instance.loadSlides();
    return true; // slides were just loaded
  }

  function slideTo(gallery, index) {
    var instance = gallery._instance;
    if (!instance || !instance.swiperInstance) return;
    var swiper = instance.swiperInstance;
    if (swiper.slides.length <= 1) return;
    if (swiper.params.loop) {
      // slideToLoop mismaps indices with slidesPerView:'auto',
      // so find the correct DOM slide by its real-index attribute
      for (var i = 0; i < swiper.slides.length; i++) {
        if (parseInt(swiper.slides[i].getAttribute('data-swiper-slide-index'), 10) === index) {
          swiper.slideTo(i, 0);
          // DO NOT REMOVE THIS loopFix. It is LOAD-BEARING for 2-image
          // galleries, not a cosmetic tweak. Swiper cannot build a working
          // loop from two slides with slidesPerView:'auto' -- it reports
          // params.loop true but leaves isEnd true on slide 2, and slideNext()
          // then moves NOTHING while still firing a transition. This call is
          // what reconciles the bookkeeping so the arrows advance at all.
          // Removed once on 2026-08-29 in the belief that it was racing
          // navigation; that broke arrow navigation on every 2-image product
          // and took ten commits to undo. Verified working with it in place.
          //
          // A zero-duration jump does not rearrange the duplicate slides a
          // looped swiper keeps either side of the real ones -- Swiper does
          // that in loopFix(). Without it the FIRST animated move afterwards
          // starts from the stale origin (slide 0), so clicking an arrow
          // appeared to slide in from the first image, once, per gallery.
          //
          // Deferred a frame on purpose. loopFix() is meant to be visually
          // invisible, but called synchronously here it runs while the swiper
          // is still settling from the destroy/recreate in loadSlides(), and
          // then it relocates to the wrong slide -- which showed up as the
          // hover sometimes not reaching the second image. Let the jump commit
          // first, and re-assert the slide if loopFix moved us off it.
          if (swiper.loopFix) {
            // One pending frame per gallery. Hovering in and out quickly used
            // to queue several, each re-asserting a different slide.
            if (gallery._loopFixFrame) cancelAnimationFrame(gallery._loopFixFrame);
            gallery._loopFixFrame = requestAnimationFrame(function () {
              gallery._loopFixFrame = 0;
              // loadSlides() destroys and recreates the instance, so the one
              // captured above can be dead by now. Compare identity rather
              // than trusting a destroyed flag the teardown may not set.
              var live = gallery._instance && gallery._instance.swiperInstance;
              if (!live || live !== swiper || swiper.destroyed) return;
              swiper.loopFix();
              for (var k = 0; k < swiper.slides.length; k++) {
                if (parseInt(swiper.slides[k].getAttribute('data-swiper-slide-index'), 10) === index) {
                  if (k !== swiper.activeIndex) swiper.slideTo(k, 0);
                  break;
                }
              }
            });
          }
          return;
        }
      }
    }
    swiper.slideTo(index, 0);
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        io.unobserve(entry.target);
        loadGallerySlides(entry.target);
      }
    });
  }, { rootMargin: '500px 0px' });

  function attachGallery(g) {
    if (g._observerAttached) return;
    g._observerAttached = true;
    if (!g._desktopSlidesLoaded) io.observe(g);

    // The hover-add strip (card-floating-add) is rendered INSIDE the card but
    // OUTSIDE <swiper-gallery>. Moving the pointer onto a size chip therefore
    // fires mouseleave here and used to snap the gallery back to image 1
    // mid-browse; moving back onto the image fired mouseenter and snapped it
    // to image 2. Neither is a real card enter/leave -- the pointer never left
    // the card. Ignore any crossing whose other side is still inside it.
    function leftTheCard(e) {
      var to = e.relatedTarget;
      if (!to || to.nodeType !== 1) return true; // left the window entirely
      var card = g.closest('.card-container');
      return !(card && card.contains(to));
    }

    g.addEventListener('mouseenter', function (e) {
      if (!leftTheCard(e)) return; // returning from the strip, not a fresh hover
      var justLoaded = loadGallerySlides(g);
      if (justLoaded) {
        // Swiper was just recreated after loading slides;
        // wait a frame for loop duplicates to settle
        requestAnimationFrame(function () {
          slideTo(g, 1);
        });
      } else {
        slideTo(g, 1);
      }
    });

    g.addEventListener('mouseleave', function (e) {
      if (!leftTheCard(e)) return; // moved onto a size chip, still on the card
      slideTo(g, 0);
    });
  }

  function observeGalleries() {
    document.querySelectorAll('swiper-gallery.swiper-product-card--slider').forEach(attachGallery);
  }

  // Watch for dynamically added galleries (e.g. product recommendations loaded via AJAX)
  var mo = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('swiper-gallery.swiper-product-card--slider')) {
          attachGallery(node);
        }
        if (node.querySelectorAll) {
          node.querySelectorAll('swiper-gallery.swiper-product-card--slider').forEach(attachGallery);
        }
      });
    });
  });
  mo.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', observeGalleries);
  document.addEventListener('shopify:section:load', observeGalleries);
  document.addEventListener('theme:section:load', observeGalleries);
}

// Featured collection tabs: scroll clicked tab to left edge on mobile
(function () {
  function initTabScroll() {
    var section = document.querySelector('.section-collection-tabs');
    if (!section) return;
    var scrollContainer = section.querySelector('.component-tabs');
    if (!scrollContainer) return;

    scrollContainer.addEventListener('click', function (event) {
      var tab = event.target.closest('.tab-js');
      if (!tab) return;
      if (window.innerWidth > 920) return;

      var containerRect = scrollContainer.getBoundingClientRect();
      var tabRect = tab.getBoundingClientRect();
      var scrollTarget = scrollContainer.scrollLeft + (tabRect.left - containerRect.left);
      var maxScrollLeft = scrollContainer.scrollWidth - scrollContainer.clientWidth;

      // Clamp to max so the last tab scrolls just enough to be fully visible
      scrollContainer.scrollTo({ left: Math.min(scrollTarget, maxScrollLeft), behavior: 'smooth' });
    });
  }

  document.addEventListener('DOMContentLoaded', initTabScroll);
  document.addEventListener('shopify:section:load', initTabScroll);
})();
